<template>
  <div class="container">
    <div v-loading="loading" class="approvals-view">
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in approvals"
          :key="index"
          :sm="12"
          :lg="6"
        >
          <el-card class="zv-box">
            <h2 class="zv-title">{{ item.title }}</h2>
            <el-row type="flex" align="bottom">
              <el-col :span="16">
                <p class="zv-p">Требует проверки:</p>
              </el-col>
              <el-col :span="4">
                <span style="font-size: 40px">{{ item.count }}</span>
              </el-col>
            </el-row>
            <router-link
              class="zv-link el-link el-link--primary"
              :to="item.path"
            >
              Перейти
            </router-link>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Approvements',
  data() {
    return {
      items: [
        { title: 'Водители', count: 10 },
        { title: 'автомобили', count: 22 },
        { title: 'контрагенты', count: 5 },
      ],
    }
  },
  computed: {
    ...mapState('approvements', {
      list: 'list',
      loading: 'loading',
    }),
    approvals() {
      let arr = []
      const drivers = this.list.find(c => c.rel === 'drivers')
      const automobiles = this.list.find(c => c.rel === 'automobiles')
      const contragents = this.list.find(c => c.rel === 'contragents')

      if (drivers) {
        const count = drivers.stats
          ? drivers.stats.by_meaning
            ? drivers.stats.by_meaning.waiting
              ? drivers.stats.by_meaning.waiting
              : 0
            : 0
          : 0

        arr.push({ title: 'Водители', path: '/driver/list?status=0', count })
      }
      if (automobiles) {
        const count = automobiles.stats
          ? automobiles.stats.by_meaning
            ? automobiles.stats.by_meaning.waiting
              ? automobiles.stats.by_meaning.waiting
              : 0
            : 0
          : 0

        arr.push({ title: 'автомобили', path: '/auto/list?status=0', count })
      }
      if (contragents) {
        const count = contragents.stats
          ? contragents.stats.by_meaning
            ? contragents.stats.by_meaning.waiting
              ? contragents.stats.by_meaning.waiting
              : 0
            : 0
          : 0

        arr.push({ title: 'контрагенты', path: '/contragents?status=0', count })
      }

      return arr
    },
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    async loadPage() {
      if (!this.loading) {
        await this.getApprovements()
      }
    },
    async getApprovements() {
      await this.$store.dispatch('approvements/fetchApprovements')
    },
  },
}
</script>
<style lang="scss">
.approvals-view {
  margin-top: 30px;
  min-height: 300px;
}
.zv-title {
  margin-top: 0;
  margin-bottom: 0.2em;
  text-transform: capitalize;
}
.zv-box {
  padding: 10px;
  margin-bottom: 20px;
}
.zv-link {
  display: inline-block;
  margin-top: 10px;
  text-decoration: underline !important;
}
</style>
